import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { DropdownItem, Permission } from 'src/app/shared/models/shared.model';
import { Bind } from 'primeng/bind';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-admin-nav-search-filter',
    templateUrl: './admin-nav-search-filter.component.html',
    styleUrls: ['./admin-nav-search-filter.component.scss'],
    imports: [Bind, Select, FormsModule]
})
export class AdminNavSearchFilterComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private authorizeService = inject(AuthorizeService);
  private route = inject(ActivatedRoute);


  //user: Profile;
  Permission = Permission;
  options: DropdownItem[];
  searchRoute: string;
  currentRoute: string;

  private unsubscribe$ = new Subject<void>();

  ngOnInit(): void {

    this.currentRoute = this.router.url;

    this.router.events.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
      }
    });

    this.authorizeService.getUser().subscribe(user => {
      if (user) {
        //this.user = user;
        this.options = [];

        this.options.push({ label: 'User Search', value: '/admin/users' });

        this.options.push({ label: 'Questions', value: '/admin/client/questions' });

        this.options.push({ label: 'Benefit Plans', value: '/admin/benefit/plan' });

        this.options.push({ label: 'Vendors', value: '/admin/benefit/vendor' });

        this.options.push({ label: 'Client', value: '/admin/client/child-clients' });

        if (this.options.length && !this.searchRoute) {
          this.searchRoute = this.options[0].value;
        }
      }
    });
  }

  navigateWithSearchFilter(searchString: string): void {

    if (this.currentRoute === this.searchRoute) {
      this.router.navigateByUrl('admin/dashboard').then(() => {
        this.router.navigate([this.searchRoute], { relativeTo: this.route, state: { searchTerm: searchString } });
      });
    } else {
      this.router.navigate([this.searchRoute], {
        relativeTo: this.route,
        state: { searchTerm: searchString },
      });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
